import styled from 'styled-components';

export const DirectoryContainer = styled.div`
  width: 100%;
  margin-top: 5rem;
  padding: 0 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
